import { W as WuiPagination$1, d as defineCustomElement$1 } from './p-Bx2FysGz.js';

const WuiPagination = WuiPagination$1;
const defineCustomElement = defineCustomElement$1;

export { WuiPagination, defineCustomElement };
